import { Injectable } from '@angular/core';
import { APIService } from './api.service';

export type InterestLevel = 'interested' | 'applied' | 'rejected' | 'won';

@Injectable({ providedIn: 'root' })
export class MarketInterestService extends APIService {
  setInterest(vacancyId: number, level: InterestLevel, consultant_User_id?: number) {
    return this.put(`/market-vacancies/${vacancyId}/interest`, { level, consultant_User_id }, null, [422]);
  }
}
